import axios from "axios";
import { clearAuthSession, getAuthSession } from "./auth.js";

const isLocalhost = window.location.hostname === "localhost";
const baseURL = process.env.REACT_APP_API_BASE_URL || (isLocalhost ? "http://localhost:8800" : "/api");

const apiClient = axios.create({
  baseURL,
});

apiClient.interceptors.request.use((config) => {
  const session = getAuthSession();
  if (session?.token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${session.token}`;
  }
  if (session?.entityId) {
    config.headers = config.headers || {};
    config.headers["x-entity-id"] = String(session.entityId);
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      clearAuthSession();
      if (window.location.pathname !== "/Login") {
        window.location.href = "/Login";
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
